import React from 'react'

// "WHAT YOU GET WITH EVERY WASH" ON /services: four cards and their photographs.
//
// The same strip every wash page carries, and it is the server's: the steps,
// the photographs, their srcset and their alt text are rendered once, by
// app/views/gwmc/_services_process.html.haml, into an inert <template> on
// every route (app/views/gwmc/index.html.haml). This section copies that
// markup in. None of this copy is written in the bundle, so the strip on
// /services and on /services/<slug> cannot disagree.
//
// No template (an HTML document cached from before it existed): render
// nothing rather than a section with a heading over nothing.
const readFragment = () => {
  if (typeof document === 'undefined') return null
  return document.getElementById('gwmc-fragment-process')?.innerHTML?.trim() || null
}

export const Process = () => {
  const html = readFragment()
  if (!html) return null

  // The template holds the whole <section>; display: contents keeps this
  // wrapper out of the layout so the band behaves like every other section.
  return <div style={{ display: 'contents' }} dangerouslySetInnerHTML={{ __html: html }} />
}
